(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.collectionListSwiperModuleInitialized) return;
    window.collectionListSwiperModuleInitialized = true;

    const sliderSelector = '[data-collection-list-slider]';
    const slideSelector = '[data-collection-list-slide]';
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let editorCleanup = null;

    const getShell = (sliderElement) => sliderElement.closest('[data-collection-list-shell]');

    const shouldEnableSlider = (sliderElement) => {
      return desktopMedia.matches
        ? sliderElement.dataset.desktopSlider === 'true'
        : sliderElement.dataset.mobileSlider === 'true';
    };

    const setActiveState = (sliderElement, active) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.classList.toggle('is-swiper-active', active);

      shell.querySelectorAll('[data-collection-list-previous], [data-collection-list-next]').forEach((button) => {
        button.tabIndex = active ? 0 : -1;
        button.setAttribute('aria-hidden', String(!active));
      });

      const pagination = shell.querySelector('[data-collection-list-pagination]');
      pagination?.setAttribute('aria-hidden', String(!active));
    };

    const resetControls = (sliderElement) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.querySelectorAll('[data-collection-list-previous], [data-collection-list-next]').forEach((button) => {
        button.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        button.removeAttribute('disabled');
      });

      const pagination = shell.querySelector('[data-collection-list-pagination]');
      if (pagination) {
        pagination.className = 'collection-list-swiper__pagination';
        pagination.replaceChildren();
      }
    };

    const destroyCollectionSlider = (sliderElement) => {
      if (!sliderElement) return;

      window.swiperFunctions.destroy(sliderElement);
      resetControls(sliderElement);
      setActiveState(sliderElement, false);
    };

    const initializeCollectionSlider = (sliderElement) => {
      if (!sliderElement) return null;

      if (!shouldEnableSlider(sliderElement)) {
        destroyCollectionSlider(sliderElement);
        return null;
      }

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);
      if (existingInstance) {
        setActiveState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const slides = sliderElement.querySelectorAll(slideSelector);
      if (slides.length < 2) {
        setActiveState(sliderElement, false);
        return null;
      }

      const shell = getShell(sliderElement);
      const previousButton = shell?.querySelector('[data-collection-list-previous]');
      const nextButton = shell?.querySelector('[data-collection-list-next]');
      const pagination = shell?.querySelector('[data-collection-list-pagination]');
      const columnsDesktop = Math.max(1, Number.parseInt(sliderElement.dataset.columnsDesktop, 10) || 4);
      const columnsMobile = Math.max(1, Number.parseInt(sliderElement.dataset.columnsMobile, 10) || 1);

      setActiveState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: columnsMobile,
        spaceBetween: 16,
        speed: prefersReducedMotion ? 0 : 450,
        watchOverflow: true,
        loop: slides.length > Math.max(columnsDesktop, columnsMobile),
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation:
          previousButton && nextButton
            ? {
                prevEl: previousButton,
                nextEl: nextButton,
              }
            : false,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: columnsDesktop,
            spaceBetween: 24,
          },
        },
        onResize(swiperInstance) {
          swiperInstance.update();
        },
        on: {
          init() {
            setActiveState(sliderElement, true);
          },
          destroy() {
            setActiveState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        resetControls(sliderElement);
        setActiveState(sliderElement, false);
      }

      return instance;
    };

    const synchronizeSliders = () => {
      document.querySelectorAll(sliderSelector).forEach((sliderElement) => {
        if (shouldEnableSlider(sliderElement)) {
          initializeCollectionSlider(sliderElement);
        } else {
          destroyCollectionSlider(sliderElement);
        }
      });
    };

    const initializeModule = () => {
      synchronizeSliders();

      editorCleanup = window.swiperFunctions.bindShopifyEditor({
        sliderSelector,
        slideSelector,
        initialize: initializeCollectionSlider,
        destroyElement: destroyCollectionSlider,
        onSectionLoad(event, sliderElement) {
          if (sliderElement) initializeCollectionSlider(sliderElement);
        },
      });

      if (typeof desktopMedia.addEventListener === 'function') {
        desktopMedia.addEventListener('change', synchronizeSliders);
      } else {
        desktopMedia.addListener(synchronizeSliders);
      }
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const moduleFlag = 'standardCollectionListMobileSwiperModuleInitialized';

    if (window[moduleFlag]) return;
    window[moduleFlag] = true;

    const sliderSelector = '[data-standard-collection-list-slider]';
    const slideSelector = '[data-standard-collection-list-slide]';
    const shellSelector = '[data-standard-collection-list-shell]';
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getShell = (sliderElement) => sliderElement.closest(shellSelector);

    const shouldEnableSlider = (sliderElement) => {
      return mobileMedia.matches && sliderElement.dataset.mobileSlider === 'true';
    };

    const setActiveState = (sliderElement, active) => {
      getShell(sliderElement)?.classList.toggle('is-swiper-active', active);
    };

    const destroyCollectionListSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return;

      window.swiperFunctions.destroy(sliderElement);
      setActiveState(sliderElement, false);
    };

    const initializeCollectionListSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return null;

      if (!shouldEnableSlider(sliderElement)) {
        destroyCollectionListSlider(sliderElement);
        return null;
      }

      const slides = Array.from(sliderElement.querySelectorAll(slideSelector));
      const columnsMobile = Math.max(1, Number.parseInt(sliderElement.dataset.columnsMobile, 10) || 1);

      if (slides.length <= columnsMobile) {
        destroyCollectionListSlider(sliderElement);
        return null;
      }

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);

      if (existingInstance) {
        setActiveState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const spaceBetween = Math.max(0, Number.parseFloat(sliderElement.dataset.spaceBetween) || 0);

      setActiveState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: columnsMobile,
        slidesPerGroup: 1,
        spaceBetween,
        speed: prefersReducedMotion ? 0 : 400,
        watchOverflow: true,
        loop: true,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        roundLengths: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: {
          enabled: true,
        },
        on: {
          init() {
            setActiveState(sliderElement, true);
          },
          destroy() {
            setActiveState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        setActiveState(sliderElement, false);
      }

      return instance;
    };

    const synchronizeSliders = () => {
      document.querySelectorAll(sliderSelector).forEach((sliderElement) => {
        if (shouldEnableSlider(sliderElement)) {
          initializeCollectionListSlider(sliderElement);
        } else {
          destroyCollectionListSlider(sliderElement);
        }
      });
    };

    const initializeModule = () => {
      synchronizeSliders();

      window.swiperFunctions.bindShopifyEditor({
        sliderSelector,
        slideSelector,
        initialize: initializeCollectionListSlider,
        destroyElement: destroyCollectionListSlider,
        onSectionLoad(event, sliderElement) {
          if (sliderElement) initializeCollectionListSlider(sliderElement);
        },
      });

      if (typeof mobileMedia.addEventListener === 'function') {
        mobileMedia.addEventListener('change', synchronizeSliders);
      } else {
        mobileMedia.addListener(synchronizeSliders);
      }
    };

    const startModule = () => {
      if (window.swiperFunctions) {
        initializeModule();
      } else {
        document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startModule, { once: true });
    } else {
      startModule();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-with-filters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.featuredCollectionTabsModuleInitialized) return;
    window.featuredCollectionTabsModuleInitialized = true;

    const sectionSelector = '[data-featured-tabs-section]';
    const sliderSelector = '[data-featured-tabs-slider]';
    const slideSelector = '[data-featured-tabs-slide]';
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getShell = (sliderElement) => sliderElement.closest('[data-featured-tabs-slider-shell]');

    const setSliderState = (sliderElement, active) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.classList.toggle('is-swiper-active', active);

      shell.querySelectorAll('[data-featured-tabs-previous], [data-featured-tabs-next]').forEach((button) => {
        button.tabIndex = active ? 0 : -1;
        button.setAttribute('aria-hidden', String(!active));
      });

      const pagination = shell.querySelector('[data-featured-tabs-pagination]');
      pagination?.setAttribute('aria-hidden', String(!active));
    };

    const resetControls = (sliderElement) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.querySelectorAll('[data-featured-tabs-previous], [data-featured-tabs-next]').forEach((button) => {
        button.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        button.removeAttribute('disabled');
      });

      const pagination = shell.querySelector('[data-featured-tabs-pagination]');
      if (pagination) {
        pagination.className = 'featured-tabs__pagination';
        pagination.replaceChildren();
      }
    };

    const destroySlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return;

      window.swiperFunctions.destroy(sliderElement);
      resetControls(sliderElement);
      setSliderState(sliderElement, false);
    };

    const initializeSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return null;

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);
      if (existingInstance) {
        setSliderState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const slides = sliderElement.querySelectorAll(slideSelector);
      if (slides.length < 2) {
        setSliderState(sliderElement, false);
        return null;
      }

      const shell = getShell(sliderElement);
      const previousButton = shell?.querySelector('[data-featured-tabs-previous]');
      const nextButton = shell?.querySelector('[data-featured-tabs-next]');
      const pagination = shell?.querySelector('[data-featured-tabs-pagination]');
      const columnsDesktop = Math.max(1, Number.parseInt(sliderElement.dataset.columnsDesktop, 10) || 4);
      const columnsMobile = Math.max(1, Number.parseInt(sliderElement.dataset.columnsMobile, 10) || 1);

      setSliderState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: columnsMobile,
        slidesPerGroup: columnsMobile,
        spaceBetween: 16,
        speed: prefersReducedMotion ? 0 : 450,
        watchOverflow: true,
        rewind: true,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation:
          previousButton && nextButton
            ? {
                prevEl: previousButton,
                nextEl: nextButton,
              }
            : false,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: columnsDesktop,
            slidesPerGroup: columnsDesktop,
            spaceBetween: 24,
          },
        },
        on: {
          init() {
            setSliderState(sliderElement, true);
          },
          resize(swiperInstance) {
            swiperInstance.update();
          },
          destroy() {
            setSliderState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        resetControls(sliderElement);
        setSliderState(sliderElement, false);
      }

      return instance;
    };

    const activateTab = (sectionElement, selectedTab, focusTab = false) => {
      if (!sectionElement || !selectedTab) return;

      const targetId = selectedTab.dataset.featuredTabsTarget;
      const tabs = Array.from(sectionElement.querySelectorAll('[data-featured-tabs-tab]'));
      const panels = Array.from(sectionElement.querySelectorAll('[data-featured-tabs-panel]'));
      const targetPanel = panels.find((panel) => panel.dataset.featuredTabsPanelId === targetId);

      if (!targetPanel) return;

      tabs.forEach((tab) => {
        const isActive = tab === selectedTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel !== targetPanel;
      });

      if (focusTab) selectedTab.focus();

      window.requestAnimationFrame(() => {
        const sliderElement = targetPanel.querySelector(sliderSelector);
        const instance = initializeSlider(sliderElement);
        instance?.update();
      });
    };

    const initializeSection = (sectionElement) => {
      if (!sectionElement || sectionElement.dataset.featuredTabsInitialized === 'true') return;

      sectionElement.dataset.featuredTabsInitialized = 'true';

      const tabs = Array.from(sectionElement.querySelectorAll('[data-featured-tabs-tab]'));
      if (!tabs.length) return;

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(sectionElement, tab));

        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex === null) return;

          event.preventDefault();
          activateTab(sectionElement, tabs[nextIndex], true);
        });
      });

      const activeTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      activateTab(sectionElement, activeTab);
    };

    const destroySection = (sectionElement) => {
      if (!sectionElement) return;

      sectionElement.querySelectorAll(sliderSelector).forEach(destroySlider);
      delete sectionElement.dataset.featuredTabsInitialized;
    };

    const initializeAllSections = () => {
      document.querySelectorAll(sectionSelector).forEach(initializeSection);
    };

    const initializeModule = () => {
      initializeAllSections();

      document.addEventListener('shopify:section:load', (event) => {
        const sectionElement = event.target.matches(sectionSelector)
          ? event.target
          : event.target.querySelector(sectionSelector);

        initializeSection(sectionElement);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const sectionElement = event.target.matches(sectionSelector)
          ? event.target
          : event.target.querySelector(sectionSelector);

        destroySection(sectionElement);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail?.blockId;
        let selectedTab = event.target.closest?.('[data-featured-tabs-tab]');
        let sectionElement = selectedTab?.closest(sectionSelector);

        if (!selectedTab && blockId) {
          document.querySelectorAll(sectionSelector).forEach((candidateSection) => {
            if (selectedTab) return;

            const candidateTab = Array.from(
              candidateSection.querySelectorAll('[data-featured-tabs-tab]')
            ).find((tab) => tab.dataset.featuredTabsBlockId === blockId);

            if (candidateTab) {
              selectedTab = candidateTab;
              sectionElement = candidateSection;
            }
          });
        }

        if (selectedTab && sectionElement) activateTab(sectionElement, selectedTab);
      });
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.featuredCollectionSwiperModuleInitialized) return;
    window.featuredCollectionSwiperModuleInitialized = true;

    const sectionSelector = '[data-featured-collection-swiper-section]';
    const sliderSelector = '[data-featured-collection-swiper]';
    const slideSelector = '[data-featured-collection-swiper-slide]';
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getShell = (sliderElement) => sliderElement?.closest('[data-featured-collection-swiper-shell]');

    const setSliderState = (sliderElement, active) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.classList.toggle('is-swiper-active', active);

      shell.querySelectorAll('[data-featured-collection-swiper-previous], [data-featured-collection-swiper-next]').forEach((button) => {
        button.tabIndex = active ? 0 : -1;
        button.setAttribute('aria-hidden', String(!active));
      });

      const pagination = shell.querySelector('[data-featured-collection-swiper-pagination]');
      pagination?.setAttribute('aria-hidden', String(!active));
    };

    const resetControls = (sliderElement) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.querySelectorAll('[data-featured-collection-swiper-previous], [data-featured-collection-swiper-next]').forEach((button) => {
        button.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        button.removeAttribute('disabled');
      });

      const pagination = shell.querySelector('[data-featured-collection-swiper-pagination]');
      if (pagination) {
        pagination.className = 'featured-collection-swiper__pagination';
        pagination.replaceChildren();
      }
    };

    const destroySlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return;

      window.swiperFunctions.destroy(sliderElement);
      resetControls(sliderElement);
      setSliderState(sliderElement, false);
    };

    const initializeSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return null;

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);
      if (existingInstance) {
        setSliderState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const slides = sliderElement.querySelectorAll(slideSelector);
      if (slides.length < 2) {
        setSliderState(sliderElement, false);
        return null;
      }

      const shell = getShell(sliderElement);
      const previousButton = shell?.querySelector('[data-featured-collection-swiper-previous]');
      const nextButton = shell?.querySelector('[data-featured-collection-swiper-next]');
      const pagination = shell?.querySelector('[data-featured-collection-swiper-pagination]');
      const columnsDesktop = Math.max(1, Number.parseInt(sliderElement.dataset.columnsDesktop, 10) || 4);
      const slidesMobile = Number.parseFloat(sliderElement.dataset.slidesMobile) || 1.5;

      setSliderState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: slidesMobile,
        slidesPerGroup: 1,
        spaceBetween: 16,
        speed: prefersReducedMotion ? 0 : 450,
        watchOverflow: true,
        rewind: true,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation:
          previousButton && nextButton
            ? {
                prevEl: previousButton,
                nextEl: nextButton,
              }
            : false,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: columnsDesktop,
            slidesPerGroup: columnsDesktop,
            spaceBetween: 24,
          },
        },
        on: {
          init() {
            setSliderState(sliderElement, true);
          },
          resize(swiperInstance) {
            swiperInstance.update();
          },
          destroy() {
            setSliderState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        resetControls(sliderElement);
        setSliderState(sliderElement, false);
      }

      return instance;
    };

    const initializeSection = (sectionElement) => {
      if (!sectionElement || sectionElement.dataset.featuredCollectionSwiperInitialized === 'true') return;

      const sliderElement = sectionElement.querySelector(sliderSelector);
      if (!sliderElement) return;

      sectionElement.dataset.featuredCollectionSwiperInitialized = 'true';
      initializeSlider(sliderElement);
    };

    const destroySection = (sectionElement) => {
      if (!sectionElement) return;

      sectionElement.querySelectorAll(sliderSelector).forEach(destroySlider);
      delete sectionElement.dataset.featuredCollectionSwiperInitialized;
    };

    const initializeAllSections = () => {
      document.querySelectorAll(sectionSelector).forEach(initializeSection);
    };

    const initializeModule = () => {
      initializeAllSections();

      document.addEventListener('shopify:section:load', (event) => {
        const sectionElement = event.target.matches(sectionSelector)
          ? event.target
          : event.target.querySelector(sectionSelector);

        initializeSection(sectionElement);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const sectionElement = event.target.matches(sectionSelector)
          ? event.target
          : event.target.querySelector(sectionSelector);

        destroySection(sectionElement);
      });
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-selector"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-fit-guide]';
    const mainSelector = '[data-fit-guide-main]';
    const thumbsSelector = '[data-fit-guide-thumbs]';

    const updateSection = (section, index, thumbInstance = null) => {
      const panels = Array.from(section.querySelectorAll('[data-fit-guide-panel]'));
      const thumbs = Array.from(section.querySelectorAll('[data-fit-guide-thumb]'));
      const activePanel = panels[index];
      const scaleIndicator = section.querySelector('[data-fit-guide-scale-indicator]');

      panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.querySelector('[data-fit-guide-thumb-button]')?.setAttribute('aria-pressed', String(active));
      });

      if (scaleIndicator && activePanel) {
        const rawPosition = Number.parseFloat(activePanel.dataset.fitGuideScalePosition);
        const scalePosition = Number.isFinite(rawPosition) ? Math.min(100, Math.max(0, rawPosition)) : 50;
        scaleIndicator.style.setProperty('--fit-guide-scale-position', `${scalePosition}%`);
      }

      if (thumbInstance) {
        thumbInstance.slideTo(index);
      }
    };

    const destroySection = (section) => {
      if (!section || !window.swiperFunctions) return;

      section.querySelectorAll(`${mainSelector}, ${thumbsSelector}`).forEach((slider) => {
        window.swiperFunctions.destroy(slider);
      });

      delete section.dataset.fitGuideInitialized;
    };

    const initializeSection = (section) => {
      if (!section || section.dataset.fitGuideInitialized === 'true' || !window.swiperFunctions) return;

      const mainElement = section.querySelector(mainSelector);
      const thumbsElement = section.querySelector(thumbsSelector);
      if (!mainElement || !thumbsElement) return;

      section.dataset.fitGuideInitialized = 'true';

      const previousButton = section.querySelector('[data-fit-guide-prev]');
      const nextButton = section.querySelector('[data-fit-guide-next]');
      const thumbButtons = Array.from(section.querySelectorAll('[data-fit-guide-thumb-button]'));
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const thumbsInstance = window.swiperFunctions.init(thumbsElement, {
        slidesPerView: 4.15,
        slidesPerGroup: 1,
        spaceBetween: 10,
        speed: prefersReducedMotion ? 0 : 350,
        watchOverflow: true,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          750: {
            slidesPerView: 7,
            spaceBetween: 22,
          },
          990: {
            slidesPerView: 8,
            spaceBetween: 26,
          },
        },
      });

      const mainInstance = window.swiperFunctions.init(mainElement, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        speed: prefersReducedMotion ? 0 : 450,
        watchOverflow: true,
        rewind: true,
        allowTouchMove: true,
        simulateTouch: true,
        observer: true,
        observeParents: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation:
          previousButton && nextButton
            ? {
                prevEl: previousButton,
                nextEl: nextButton,
              }
            : false,
        on: {
          init(swiper) {
            updateSection(section, swiper.realIndex || 0, thumbsInstance);
          },
          slideChange(swiper) {
            updateSection(section, swiper.realIndex || 0, thumbsInstance);
          },
        },
      });

      thumbButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          if (!mainInstance) return;
          mainInstance.slideTo(index);
          updateSection(section, index, thumbsInstance);
        });
      });
    };

    const initializeAll = () => {
      document.querySelectorAll(sectionSelector).forEach(initializeSection);
    };

    const initializeModule = () => {
      initializeAll();

      document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.matches(sectionSelector)
          ? event.target
          : event.target.querySelector(sectionSelector);

        initializeSection(section);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const section = event.target.matches(sectionSelector)
          ? event.target
          : event.target.querySelector(sectionSelector);

        destroySection(section);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const block = event.target.closest?.('[data-fit-guide-main-slide]');
        const section = event.target.closest?.(sectionSelector);
        if (!section || !block) return;

        const slides = Array.from(section.querySelectorAll('[data-fit-guide-main-slide]'));
        const index = slides.indexOf(block);
        const mainElement = section.querySelector(mainSelector);
        const thumbsElement = section.querySelector(thumbsSelector);
        const mainInstance = window.swiperFunctions?.getInstance(mainElement);
        const thumbsInstance = window.swiperFunctions?.getInstance(thumbsElement);

        if (index >= 0 && mainInstance) {
          mainInstance.slideTo(index);
          updateSection(section, index, thumbsInstance);
        }
      });
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.testimonialsSwiperModuleInitialized) return;
    window.testimonialsSwiperModuleInitialized = true;

    const sliderSelector = '[data-testimonials-slider]';
    const slideSelector = '[data-testimonials-slide]';
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getShell = (sliderElement) => {
      return sliderElement.closest('[data-testimonials-shell]');
    };

    const shouldEnableSlider = (sliderElement) => {
      return desktopMedia.matches
        ? sliderElement.dataset.desktopSlider === 'true'
        : sliderElement.dataset.mobileSlider === 'true';
    };

    const setActiveState = (sliderElement, active) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.classList.toggle('is-swiper-active', active);

      shell.querySelectorAll('[data-testimonials-previous], [data-testimonials-next]').forEach((button) => {
        button.tabIndex = active ? 0 : -1;
        button.setAttribute('aria-hidden', String(!active));
      });

      const pagination = shell.querySelector('[data-testimonials-pagination]');
      pagination?.setAttribute('aria-hidden', String(!active));
    };

    const resetControls = (sliderElement) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.querySelectorAll('[data-testimonials-previous], [data-testimonials-next]').forEach((button) => {
        button.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        button.removeAttribute('disabled');
      });

      const pagination = shell.querySelector('[data-testimonials-pagination]');

      if (pagination) {
        pagination.className = 'testimonials-swiper__pagination';
        pagination.replaceChildren();
      }
    };

    const destroyTestimonialsSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return;

      window.swiperFunctions.destroy(sliderElement);
      resetControls(sliderElement);
      setActiveState(sliderElement, false);
    };

    const initializeTestimonialsSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return null;

      if (!shouldEnableSlider(sliderElement)) {
        destroyTestimonialsSlider(sliderElement);
        return null;
      }

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);

      if (existingInstance) {
        setActiveState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const slides = sliderElement.querySelectorAll(slideSelector);

      if (slides.length < 2) {
        setActiveState(sliderElement, false);
        return null;
      }

      const shell = getShell(sliderElement);
      const previousButton = shell?.querySelector('[data-testimonials-previous]');
      const nextButton = shell?.querySelector('[data-testimonials-next]');
      const pagination = shell?.querySelector('[data-testimonials-pagination]');
      const columnsDesktop = Math.max(1, Number.parseInt(sliderElement.dataset.columnsDesktop, 10) || 4);
      const columnsMobile = Math.max(1, Number.parseInt(sliderElement.dataset.columnsMobile, 10) || 1);

      setActiveState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: columnsMobile,
        spaceBetween: 16,
        speed: prefersReducedMotion ? 0 : 450,
        watchOverflow: true,
        loop: slides.length > Math.max(columnsDesktop, columnsMobile),
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation: false,
        pagination: false,
        breakpoints: {
          750: {
            slidesPerView: columnsDesktop,
            spaceBetween: 24,
          },
        },
        onResize(swiperInstance) {
          swiperInstance.update();
        },
        on: {
          init() {
            setActiveState(sliderElement, true);
          },
          destroy() {
            setActiveState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        resetControls(sliderElement);
        setActiveState(sliderElement, false);
      }

      return instance;
    };

    const synchronizeSliders = () => {
      document.querySelectorAll(sliderSelector).forEach((sliderElement) => {
        if (shouldEnableSlider(sliderElement)) {
          initializeTestimonialsSlider(sliderElement);
        } else {
          destroyTestimonialsSlider(sliderElement);
        }
      });
    };

    const initializeModule = () => {
      synchronizeSliders();

      window.swiperFunctions.bindShopifyEditor({
        sliderSelector,
        slideSelector,
        initialize: initializeTestimonialsSlider,
        destroyElement: destroyTestimonialsSlider,
        onSectionLoad(event, sliderElement) {
          if (sliderElement) initializeTestimonialsSlider(sliderElement);
        },
      });

      if (typeof desktopMedia.addEventListener === 'function') {
        desktopMedia.addEventListener('change', synchronizeSliders);
      } else {
        desktopMedia.addListener(synchronizeSliders);
      }
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, {
        once: true,
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (() => {
    if (window.relatedProductsSwiperModuleInitialized) return;
    window.relatedProductsSwiperModuleInitialized = true;

    const sliderSelector = '[data-related-products-slider]';
    const slideSelector = '[data-related-products-slide]';
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let editorCleanup = null;
    let recommendationsObserver = null;

    const getShell = (sliderElement) => sliderElement.closest('[data-related-products-shell]');

    const shouldEnableSlider = (sliderElement) => {
      return desktopMedia.matches
        ? sliderElement.dataset.desktopSlider === 'true'
        : sliderElement.dataset.mobileSlider === 'true';
    };

    const setActiveState = (sliderElement, active) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.classList.toggle('is-swiper-active', active);

      shell.querySelectorAll('[data-related-products-previous], [data-related-products-next]').forEach((button) => {
        button.tabIndex = active ? 0 : -1;
        button.setAttribute('aria-hidden', String(!active));
      });

      const pagination = shell.querySelector('[data-related-products-pagination]');
      pagination?.setAttribute('aria-hidden', String(!active));
    };

    const resetControls = (sliderElement) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.querySelectorAll('[data-related-products-previous], [data-related-products-next]').forEach((button) => {
        button.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        button.removeAttribute('disabled');
      });

      const pagination = shell.querySelector('[data-related-products-pagination]');
      if (pagination) {
        pagination.className = 'related-products-swiper__pagination';
        pagination.replaceChildren();
      }
    };

    const destroyRelatedProductsSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return;

      window.swiperFunctions.destroy(sliderElement);
      resetControls(sliderElement);
      setActiveState(sliderElement, false);
    };

    const initializeRelatedProductsSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return null;

      if (!shouldEnableSlider(sliderElement)) {
        destroyRelatedProductsSlider(sliderElement);
        return null;
      }

      const slides = sliderElement.querySelectorAll(slideSelector);
      if (slides.length < 2) {
        setActiveState(sliderElement, false);
        return null;
      }

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);
      if (existingInstance) {
        setActiveState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const shell = getShell(sliderElement);
      const previousButton = shell?.querySelector('[data-related-products-previous]');
      const nextButton = shell?.querySelector('[data-related-products-next]');
      const pagination = shell?.querySelector('[data-related-products-pagination]');
      const columnsDesktop = Math.max(1, Number.parseInt(sliderElement.dataset.columnsDesktop, 10) || 4);
      const columnsMobile = Math.max(1, Number.parseInt(sliderElement.dataset.columnsMobile, 10) || 2);
      const loopRequested = sliderElement.dataset.enableLoop === 'true';
      const enableLoop = loopRequested && slides.length > Math.max(columnsDesktop, columnsMobile);

      setActiveState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: columnsMobile,
        spaceBetween: 16,
        speed: prefersReducedMotion ? 0 : 450,
        watchOverflow: true,
        loop: enableLoop,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation:
          previousButton && nextButton
            ? {
                prevEl: previousButton,
                nextEl: nextButton,
              }
            : false,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: columnsDesktop,
            spaceBetween: 24,
          },
        },
        onResize(swiperInstance) {
          swiperInstance.update();
        },
        on: {
          init() {
            setActiveState(sliderElement, true);
          },
          destroy() {
            setActiveState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        resetControls(sliderElement);
        setActiveState(sliderElement, false);
      }

      return instance;
    };

    const initializeWithin = (root = document) => {
      if (root instanceof Element && root.matches(sliderSelector)) {
        initializeRelatedProductsSlider(root);
      }

      root.querySelectorAll?.(sliderSelector).forEach((sliderElement) => {
        initializeRelatedProductsSlider(sliderElement);
      });
    };

    const synchronizeSliders = () => {
      document.querySelectorAll(sliderSelector).forEach((sliderElement) => {
        if (shouldEnableSlider(sliderElement)) {
          initializeRelatedProductsSlider(sliderElement);
        } else {
          destroyRelatedProductsSlider(sliderElement);
        }
      });
    };

    const observeRecommendationRendering = () => {
      recommendationsObserver?.disconnect();

      recommendationsObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;
            initializeWithin(node);
          });
        });
      });

      recommendationsObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    };

    const initializeModule = () => {
      synchronizeSliders();
      observeRecommendationRendering();

      editorCleanup = window.swiperFunctions.bindShopifyEditor({
        sliderSelector,
        slideSelector,
        initialize: initializeRelatedProductsSlider,
        destroyElement: destroyRelatedProductsSlider,
        onSectionLoad(event, sliderElement) {
          if (sliderElement) {
            initializeRelatedProductsSlider(sliderElement);
          } else if (event?.target) {
            initializeWithin(event.target);
          }
        },
      });

      if (typeof desktopMedia.addEventListener === 'function') {
        desktopMedia.addEventListener('change', synchronizeSliders);
      } else {
        desktopMedia.addListener(synchronizeSliders);
      }
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
